import React, { useEffect, useState } from 'react';

/**
 * YatasGeoSunum: Yataş ekibine yapay zekâ görünürlüğü (GEO) anlatım destesi, 13 slayt (2 Eki 2026).
 * Route: /r/yatas-geo-sunum (sidebar YOK, tam ekran slayt 16:9).
 * Yeniden üretmek için: node src/pages/yatas-geo-sunum/build.js (PDF dahil)
 *
 * 🔴 iframe'e sandbox EKLEME, PDF indirme kırılır.
 * HTML modülü ~68KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function YatasGeoSunum() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./yatasGeoSunumHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="Yataş · Yapay Zekâ Görünürlüğü"
      srcDoc={html}
      style={fill}
    />
  );
}
